/**
 * Thin split-canvas bindings over the document-canvas active-page API, so
 * consumers outside this feature need neither the store context nor
 * document-canvas internals.
 */
import { useScrollToPage } from '../document-canvas';
import {
  useSplitCanvasStore,
  useSplitCanvasStoreApi,
} from './SplitCanvasProvider';

/** Id of the page currently active in the split canvas (null before layout). */
export const useActiveSplitPage = () =>
  useSplitCanvasStore(state => state.pageLayout.activeId);

/** Pans the split canvas so the given page is aligned to the top. */
export const useScrollToSplitPage = () =>
  useScrollToPage(useSplitCanvasStoreApi());
